export enum ViewShareLinkBlock {
  Root = 'ViewShareLink',
}

export enum ViewShareLinkElement {
  Header = 'header',
  Action = 'action',
  Actions = 'actions',
}
